import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'

import {getExportState} from './selectors'
import {exportTaskListCsv} from './actions'
import {thereAreTableTasks} from '../tasksTable/selectors'
import ExportCSVButton from '../../components/ExportCSVButton'

class ExportTaskListCSVButton extends ExportCSVButton {
    constructor(props) {
        super({
            ...props,
            labelMessageKey: 'task.list.export.csv',
            noDataMessageKey: 'task.list.export.no_data'
        })
    }
}

export default connect(
    (state) => ({
        disabled: getExportState(state).inProgress ? false : !thereAreTableTasks(state),
        inProgress: getExportState(state).inProgress,
    }),
    (dispatch) => ({
        exportAction: bindActionCreators(exportTaskListCsv, dispatch),
    })
)(ExportTaskListCSVButton)



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/CsvExportButton.js